module.exports = __webpack_public_path__ + "img/feature-update.2617d484.png";